import { useQuery } from "@tanstack/react-query";
import { GET_COURSE_TASK_DETAILS, getCourseTaskDetails } from "..";

export const useCourseTaskDetailsQuery = ({
  load = false,
  courseTaskId = "",
  studentTaskId = "",
}) => {
  return useQuery({
    queryKey: [GET_COURSE_TASK_DETAILS, courseTaskId, studentTaskId],
    queryFn: () => getCourseTaskDetails(courseTaskId, studentTaskId),
    enabled: !!courseTaskId && load,
  });
};
